import createCrud from '../../crud';

export default createCrud({
    resource: 'sprints',
    parent: 'yodizuserstorydoc',
    getters: {
      getActiveSprint: (state) => () => {
        return state.list.find(sprint => {
          return sprint.status === 'Active';
        })
      }
    }
  })